import React from "react";
import { ArrowRight, Lightbulb } from "lucide-react";
import { Link } from "react-router-dom";

const stats = [
    { number: "10+", subtitle: "Years experience" },
    { number: "50+", subtitle: "Projects delivered" },
    { number: "10+", subtitle: "Global clients" },
    { number: "5", subtitle: "Products and platforms" },
];

export default function HomeHeroSection() {
    return (
        <div className="relative overflow-hidden bg-[#03152d] text-white min-h-[90vh] flex flex-col justify-center pt-28 pb-16">

            {/* Background Dark Blue Blob */}
            <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] sm:w-[800px] sm:h-[800px] rounded-full bg-[#0a1a36] pointer-events-none" />

            <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
                <div className="max-w-4xl">
                    {/* Badge */}
                    <div className="mb-6 inline-flex items-center px-4 py-2 rounded bg-[#0b214a] text-[#559df4] text-sm font-medium">
                        <Lightbulb className="w-4 h-4 mr-2" />
                        Accelerating digital innovation since 2016
                    </div>

                    {/* Heading */}
                    <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold leading-tight tracking-wide mb-6">
                        Your technology and innovation<br />partner
                    </h1>

                    {/* Subtitle */}
                    <p className="text-lg sm:text-2xl text-gray-300 max-w-3xl mb-10 leading-relaxed">
                        We build AI, OTT, and enterprise software that turns ambitious ideas
                        into production-grade platforms, for clients across India and the USA.
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex flex-wrap items-center gap-4 mb-16">
                        <Link
                            to="/contact"
                            className="inline-flex items-center justify-center bg-[#337aed] hover:bg-[#2563cd] text-white font-medium px-6 py-3 rounded transition-colors"
                        >
                            Start a project <ArrowRight className="ml-2 w-5 h-5" />
                        </Link>
                        <Link
                            to="/portfolio"
                            className="inline-flex items-center justify-center bg-[#0b214a] hover:bg-[#132c5e] border border-blue-800/50 text-white font-medium px-6 py-3 rounded transition-colors"
                        >
                            See our work
                        </Link>
                    </div>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl">
                    {stats.map((item, index) => (
                        <div key={index} className="bg-[#2734a3] rounded-xl p-6 sm:p-8 flex flex-col justify-center">
                            <span className="text-4xl sm:text-5xl font-bold mb-2">{item.number}</span>
                            <span className="text-gray-400 text-sm sm:text-base font-medium">
                                {item.subtitle}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
